import { axios } from '@/utils/request'

const api = {
  getGoogleAuthConfig: '/5d9bf8d2eeff6',
  bindGoogleAuth: '/5d919d06266d9',
  cancelGoogleAuth: '/5d9bfc13d308c',
  sendCancelGoogleAuthCaptcha: '/5d9bfa98969e8',
  checkGoogleAuth: '/5d91a4cfc1250',
  // 发送修改手机号验证码
  // sendCModifyCaptcha:'/62fd9ee156d2c',
  sendCModifyCaptcha: '/68a7d1b866db3',
  modifyPhoneNumber: '/62fd91ebdb3ba',
}

export default {
  // 获取谷歌验证器信息
  getGoogleAuthConfig() {
    const parameter = {}
    return axios({
      url: api.getGoogleAuthConfig,
      method: 'get',
      params: parameter,
    })
  },
  // 绑定谷歌验证器
  bindGoogleAuth: ({ google_secret, google_code }) => {
    const parameter = { google_secret, google_code }
    return axios({
      url: api.bindGoogleAuth,
      method: 'post',
      data: parameter,
    })
  },
  // 取消绑定谷歌验证器
  cancelGoogleAuth: ({ captcha }) => {
    const parameter = { captcha }
    return axios({
      url: api.cancelGoogleAuth,
      method: 'get',
      params: parameter,
    })
  },
  // 发送删除谷歌验证验证码
  sendCancelGoogleAuthCaptcha: () => {
    const parameter = {}
    return axios({
      url: api.sendCancelGoogleAuthCaptcha,
      method: 'get',
      params: parameter,
    })
  },
  //发送修改手机号验证码
  sendCModifyCaptcha: ({ captchaCode, captchaId, phoneNumber }) => {
    const parameter = { captchaCode, captchaId, phoneNumber }
    return axios({
      url: api.sendCModifyCaptcha,
      method: 'post',
      data: parameter,
    })
  },
  //确定修改手机号
  modifyPhoneNumber: ({ captcha, mobile }) => {
    const parameter = { captcha, mobile }
    return axios({
      url: api.modifyPhoneNumber,
      method: 'get',
      params: parameter,
    })
  },
  // 验证谷歌授权
  checkGoogleAuth: ({ google_code }) => {
    const parameter = { google_code }
    return axios({
      url: api.checkGoogleAuth,
      method: 'get',
      params: parameter,
    })
  },
}
